import {ResourceType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/ResourceType'

// One definition of "does a scoped socket payload concern this scope": the global scope is a
// superset of every resource scope, so it matches every payload; a resource scope matches global
// payloads (they cover all resources) and its own resource's payloads. Both the counts store and
// the list composable must agree on this, or the badge and the rendered list drift apart.
export function doesNotificationPayloadScopeMatchScope(
  scopeResourceType: ResourceType | null,
  scopeResourceId: string | null,
  payloadResourceType?: ResourceType | null,
  payloadResourceId?: string | null,
): boolean {
  if(!scopeResourceType || !scopeResourceId) {
    return true
  }
  const isGlobalPayload = !payloadResourceType && !payloadResourceId
  if(isGlobalPayload) {
    return true
  }
  return scopeResourceType === payloadResourceType && scopeResourceId === payloadResourceId
}
